import { BlockId, blockPropsMap } from '../../../game/defs/block';
import { TabScreenOptions } from '../../../odie/plugins/nav/TabNav';
import { BlockButton, BlockButtonType } from '../../ui/BlockButton';
import { BasicTabScreen } from '../../../lib/ui/BasicTabScreen';
import { EditorScreen } from '../../EditorScreen';

const blocksAvailableToSpawn: BlockId[] = [
  'basicBlue',
  'basicGreen',
  'basicPurple',
  'basicRed',
  'basicYellow',
  'hatAll',
  'hatBlue',
  'hatGreen',
  'hatPurple',
  'hatRed',
  'hatYellow',
  'kettle',
  'skull',
  'pantherSmall',
  'chameleon',
  'spider',
  'bubbles',
  'tunaCan',
  'tvAll',
  'cooler',
  'firebox',
  'fireboxLollipop',
  'statue',
  'lock',
  'chocolateEgg',
  'rocketHorizontal',
  'rocketVertical',
  'cubeBlue',
  'cubeGreen',
  'cubePurple',
  'cubeRed',
  'cubeYellow',
  'bomb',
  'shell',
];

/*
    puzzle editor spawn menu
*/
export class EditorSpawnMenu extends BasicTabScreen {
  // fields
  //-------------------------------------------------------------------------
  // scene
  private readonly _buttons: BlockButton[] = [];
  private _screen?: EditorScreen;

  // properties
  //-------------------------------------------------------------------------
  public static assets(): string[] {
    return BlockButton.assets();
  }

  public get spawns(): BlockId[] {
    // return selected block ids
    return this._buttons
      .filter((button) => button.selected)
      .map((button) => button.def.id);
  }

  public set spawns(spawns: BlockId[]) {
    // update selected buttons
    for (const button of this._buttons) {
      button.selected = spawns.includes(button.def.id);
    }
  }

  // init
  //-------------------------------------------------------------------------
  constructor(options: TabScreenOptions) {
    super(options);

    // spawn buttons
    this._spawnButtons();
  }

  public async prepare(options: { screen: EditorScreen }) {
    // set fields
    this._screen = options.screen;
  }

  // private: events
  //-------------------------------------------------------------------------
  private _onButtonPress(button: BlockButton) {
    // toggle selected
    button.selected = !button.selected;
    this._screen?.goalMenu.autoUpdate(this._screen);
    this._screen?.blockMenu.updateDynamicOptions(this._screen);
    this._screen?.setAsUnsaved();
  }

  // private: spawn
  //-------------------------------------------------------------------------
  private _spawnButtons() {
    let x = 0;
    let y = 0;
    const space = 78;

    // spawn remaining block buttons
    Object.keys(blockPropsMap)
      .filter((key: string) => {
        const { noEditor } = blockPropsMap[key as BlockId];
        return !noEditor && blocksAvailableToSpawn.includes(key as BlockId);
      })
      .forEach((blockId) => {
        // spawn block button
        const button = this._spawnButton(x, y, 'block', blockId as BlockId); // add to list
        this._buttons.push(button);

        // iterate position
        x += space;
        if (x >= this.width - space) {
          x = 0;
          y += space;
        }
      });
  }

  private _spawnButton(
    x: number,
    y: number,
    type: BlockButtonType,
    blockId?: BlockId,
  ): BlockButton {
    // create button
    const button = new BlockButton({
      type,
      def: { id: blockId! },
    });
    button.x = x;
    button.y = y;

    // register events
    button.onTap = () => this._onButtonPress(button);
    button.initListeners();

    // spawn
    this.view.addChild(button);

    return button;
  }
}
